// App.js
import { Routes, Route } from "react-router-dom";


import "react-quill/dist/quill.snow.css";

import Home from "./components/home/Home";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import ResetPassword from "./components/login/resetPassword/resetPassword.jsx";
import ForgotPassword from "./components/login/forgotpassword/forgotPassword.jsx";

import Login from "./components/login/login/login.jsx";
import SignUp from "./components/login/signup/signup.jsx";
import VerifyEmail from "./components/login/verifyEmail/verifyEmail.jsx";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { loadUserAction } from "./redux/actions/userActions.js";
import PageNotFound from "./components/PageNotFound/PageNotFound.jsx";
import Profile from "./components/profile/Profile.jsx";
import MyUpcScanSlips from "./components/allSlips/AllSlips.jsx";
import InventoryLookup from "./components/inventory/InventoryLookup.jsx";
import ExportExcelFile from "./components/ExportExcelFile.jsx";
import ProductCatalog from "./components/products/ProductCatalog/ProductCatalog.jsx";
import AddProduct from "./components/products/AddProduct.jsx";
import ImportProducts from "./components/products/importProducts.jsx";
import UpdateProduct from "./components/products/updateProduct/UpdateProduct.jsx";
import BarcodeMapping from "./components/products/BarcodeMapping.jsx";
import AdminHome from "./components/admin/AdminHome.jsx";
import AdminDashboard from "./components/admin/AdminDashboard.jsx";
import AdminAnalytics from "./components/admin/AdminAnalytics.jsx";
import StoreManagement from "./components/admin/StoreManagement.jsx";
import UserManagement from "./components/admin/UserManagement.jsx";
import WholesalePriceBook from "./components/admin/WholesalePriceBook.jsx";
import PurchaseRecords from "./components/stockRecords/PurchaseRecords.jsx";
import SaleRecords from "./components/stockRecords/SaleRecords.jsx";
import AnalyticsDashboard from "./components/analytics/AnalyticsDashboard.jsx";


const App = () => {
  const dispatch = useDispatch();


  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(loadUserAction());
    }, 0);

    return () => clearTimeout(timer);
  }, [dispatch]);


  return (
    <>
      <ToastContainer
        position={window.innerWidth < 600 ? "bottom-center" : "bottom-right"}
        autoClose={1500}
        theme="colored"
        pauseOnHover
        hideProgressBar={false}
        closeOnClick
      />



      <Routes>
        <Route path="/" element={<Home />}>
          <Route index element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/my-upc-scan-slip" element={<MyUpcScanSlips />} />
          <Route path="/inventory-lookup" element={<InventoryLookup />} />
          <Route path="/export-excel-file" element={<ExportExcelFile />} />
          <Route path="/product-catalog" element={<ProductCatalog />} />
          <Route path="/add-products" element={<AddProduct />} />
          <Route path="/import-products" element={<ImportProducts />} />
          <Route path="/update-product" element={<UpdateProduct />} />
          <Route path="/purchase-records" element={<PurchaseRecords />} />
          <Route path="/sale-records" element={<SaleRecords />} />
        </Route>

        <Route path="/admin" element={<AdminHome />}>
          <Route index element={<AdminDashboard />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="stores" element={<StoreManagement />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="barcode-mapping" element={<BarcodeMapping />} />
          <Route path="wholesale-price-book" element={<WholesalePriceBook />} />
          <Route path="purchase-records" element={<PurchaseRecords />} />
          <Route path="sale-records" element={<SaleRecords />} />
        </Route>

        <Route path="/login/" element={<Login />} />
        <Route path="/signup/" element={<SignUp />} />
        <Route path="/verify-email/" element={<VerifyEmail />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/forgot-password/" element={<ForgotPassword />} />
        <Route path="/*" element={<PageNotFound />} />

      </Routes>
    </>
  );
};

export default App;
